var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShiftsActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "novedades_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_206",
    "data-name": "Rect\\xE1ngulo 206",
    width: 34,
    height: 34,
    transform: "translate(767 692)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_28",
    "data-name": "Rect\\xE1ngulo 28",
    width: 26.093,
    height: 24.264,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_20",
    "data-name": "Enmascarar grupo 20",
    transform: "translate(-767 -692)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(771.446 697.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M0,15.69a5.115,5.115,0,0,1,.527-.677Q4.416,11.424,8.32,7.851a1.466,1.466,0,0,1,2.533,1.125c-.01.776,0,1.553,0,2.363h.378q2.322,0,4.644,0c.662,0,.948.287.949.949,0,.927,0,1.855,0,2.872l7.336-6.732L16.822,1.7v.387c0,.855,0,1.71,0,2.565a.773.773,0,0,1-.835.861q-5.748.006-11.5,0a.77.77,0,0,1-.825-.738.791.791,0,0,1,.792-.814c.108-.008.216,0,.325,0H15.263c0-.854-.007-1.674,0-2.494A1.432,1.432,0,0,1,16.6.006a1.584,1.584,0,0,1,1.249.511q2,1.851,4.017,3.691L25.67,7.7c.557.512.565.937.014,1.444q-3.957,3.635-7.917,7.267a1.459,1.459,0,0,1-2.5-1.088c0-.79,0-1.58,0-2.424h-.349q-2.338,0-4.676,0c-.656,0-.944-.292-.945-.954,0-.926,0-1.853,0-2.865l-7.334,6.73,7.31,6.709c.01-.134.023-.222.024-.309,0-.855,0-1.71,0-2.565,0-.626.287-.916.911-.916q4.968,0,9.937,0c.581,0,.92.286.923.766s-.348.791-.943.791q-4.4,0-8.8,0h-.469v.783c0,.53,0,1.061,0,1.591a1.441,1.441,0,0,1-1.216,1.559.409.409,0,0,0-.085.045H9.224a5.289,5.289,0,0,1-.959-.562Q4.366,20.159.5,16.579a4.23,4.23,0,0,1-.5-.694V15.69",
    transform: "translate(0 0)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShiftsActive);
export default __webpack_public_path__ + "static/media/icon_shifts_active.cdb0ce164a422284a43693681cb41b06.svg";
export { ForwardRef as ReactComponent };